import { ClickableTile } from "@carbon/react";
import { useTranslation } from "react-i18next";
import { PurchaseOrderStatus, PurchaseOrderStatusCounts } from "../../../types";
import "../purchaseOrders.scss";

interface OcStatTilesProps {
  counts: PurchaseOrderStatusCounts;
  onSelect: (status: PurchaseOrderStatus) => void;
  /** The currently-filtered status, so its tile reads as active. */
  selected?: PurchaseOrderStatus;
}

/** The four buyer-meaningful buckets, in the prototype's order, each with its accent colour
 * (matching the status pill family) and its i18n key under `purchaseOrders.tiles.*`. */
const TILES: { status: PurchaseOrderStatus; key: string; accent: string }[] = [
  { status: "PENDING_APPROVAL", key: "pendingApproval", accent: "warmgray" },
  { status: "SENT", key: "pendingAcceptance", accent: "blue" },
  { status: "IN_DELIVERY", key: "inDelivery", accent: "teal" },
  { status: "DELIVERED", key: "delivered", accent: "green" },
];

/**
 * Summary stat tiles above the OC list: a clickable count per buyer-meaningful status. Clicking a
 * tile asks the page to filter by that status (the page decides toggle/clear semantics).
 */
const OcStatTiles = ({ counts, onSelect, selected }: OcStatTilesProps) => {
  const { t } = useTranslation();
  return (
    <div className="purchase-orders__tiles">
      {TILES.map(({ status, key, accent }) => (
        <ClickableTile
          key={status}
          className={
            `purchase-orders__tile purchase-orders__tile--${accent}` +
            (selected === status ? " purchase-orders__tile--selected" : "")
          }
          aria-pressed={selected === status}
          onClick={() => onSelect(status)}
        >
          <span className="purchase-orders__tile-count">
            {counts[status] ?? 0}
          </span>
          <span className="purchase-orders__tile-title">
            {t(`purchaseOrders.tiles.${key}.title`)}
          </span>
          <span className="purchase-orders__tile-subtitle">
            {t(`purchaseOrders.tiles.${key}.subtitle`)}
          </span>
        </ClickableTile>
      ))}
    </div>
  );
};

export default OcStatTiles;
